import ProductPayLinkPage from "./ProductPayLinkPage";

export default ProductPayLinkPage;
